


export default {

  mixins:[],
    components: {},

    data : function(){
        return {
            card_ref :'', // model for card reference field
            pin      :'', // model for pin field
            submitted:false, // The form has been submitted and is processing
            card     :false, // The retrieved card object from the graph api
            hideForm :false  // is the form hidden?
        };
    },

    created : function(){

      /*
      * the register journey navigates to this page upon succesfull registration of a card,
      * we already have the details needed, so skip the form and go straight to the balance screen
      */
      if(this.$route.params.card_reference_input && this.$route.params.pin_input){
        this.card_ref = this.$route.params.card_reference_input;
        this.pin      = this.$route.params.pin_input;
        this.hideForm = true;
        this.getBalance();
      }

    },

    computed: {

      account() {
          return this.$store.getters.getAccount;
      }
    },
    mounted : function ()
    {

    },
    methods:{

        /*
        * Form submission action.
        * Validates the form and then submits to the API
        */
        submit(){
            this.submitted = false;
            this.$validator.validateAll().then((result) => {
                if (result){
                    this.submitted = true;
                    this.getBalance();
                } else {
                    this.scrollToError();
                }
            });
        },


        /*
        * Get card balance/details from the API
        * On success, hides the form and shows the balance.
        */

        getBalance(removeDashes = false){

           //remove whitespace from the card number
          let cardRef = this.card_ref.replace(/\s+/g, '');

           //check if there are any dashes in the card number
          let dashSearchResult = /-/g.test(cardRef);

           //if this is the second call, remove dashes,
          if(removeDashes) {
            cardRef = cardRef.replace(/-/g,'');
          } else {
            if(!dashSearchResult) {
               //else, if no dashes found in card number,flick the bool so api call is only made once
              removeDashes = true;
            }
          }

          this.$axios({
            url: this.baseGraphURL,
            method: 'post',
            data: {
              query: `
                  query($account_id:Int!, $limit:Int!,$page:Int!,$card_reference:String!,$pin:String!){
                      Cards(account_id:$account_id, card_reference:$card_reference,pin:$pin, limit:$limit, page:$page){
                        data{
                          card_reference,
                          balance,
                          product_name,
                          expiry_time,
                          validity_start_time,
                          card_alias_card_reference,
                          price_modifier_description,
                          Currency{
                              symbol,
                              denomination
                          }, 
                        }
                        total,
                        per_page
                      },
                  }
                `,
                variables: {
                  card_reference     : cardRef,
                  pin                : this.pin,
                  page               : 1,
                  limit              : 1,
                  account_id : this.account.id
                }
            }
          }).then((result) => {
            this.submitted = false;
            if(result.data.data.Cards.data.length){ // card found
              this.hideForm = true;
              this.card = result.data.data.Cards.data[0];

              if((this.$route.params.card_reference_input && this.card.card_alias_card_reference == this.$route.params.card_reference_input) || (this.card_ref == this.card.card_alias_card_reference))
                this.card.card_reference = this.card.card_alias_card_reference;

            }else{ // card not found
              if(!removeDashes) {
                //if dashes were found in the card number, make second api call where dashes will be removed
                this.getBalance(true);
              } else {
                this.hideForm = false;
                this.errors.add({field:'card_ref',msg:"Sorry, we couldn't find that card/pin combination. Please check the details you entered."});
              }
            }
          }).catch((error)=>{ // uncaught error
            if(!removeDashes) {
              //if dashes were found in the card number, make second api call where dashes will be removed
              this.getBalance(true);
            } else {
              this.hideForm = false;
              this.errors.add({field:'card_ref',msg:"Something's gone wrong trying to find this card. Please try again shortly."});
            }
          });

        }

    },

    head() {
        return {
            title: 'Check your gift card balance - ' + this.$store.getters.getAccount.name
        }
    }
}
